import { Button } from '@hivebrite/design-system/Button';

import { DefaultLink } from 'hb-react/frontoffice/components/Link';

const getPageCustomizableHeaderControls = ({
  appPageConfig: { config = {} } = {},
}) => {
  const {
    primary_button_enabled: primaryButtonEnabled,
    primary_button_label: primaryButtonLabel,
    primary_button_url: primaryButtonUrl,
    secondary_button_enabled: secondaryButtonEnabled,
    secondary_button_label: secondaryButtonLabel,
    secondary_button_url: secondaryButtonUrl,
  } = config;

  const primaryButton = primaryButtonEnabled && primaryButtonUrl && (
    <DefaultLink href={primaryButtonUrl} data-bypass-router target="_blank">
      <Button>{primaryButtonLabel}</Button>
    </DefaultLink>
  );

  const secondaryButton = secondaryButtonEnabled && secondaryButtonUrl && (
    <DefaultLink href={secondaryButtonUrl} data-bypass-router target="_blank">
      <Button variant="secondary">{secondaryButtonLabel}</Button>
    </DefaultLink>
  );

  return {
    controls: [primaryButton, secondaryButton].filter(Boolean),
    primaryButton,
    secondaryButton,
  };
};

export default getPageCustomizableHeaderControls;
